import { render, staticRenderFns } from "./AdminUsers.vue?vue&type=template&id=c7af4a70&scoped=true"
import script from "./AdminUsers.vue?vue&type=script&lang=js"
export * from "./AdminUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7af4a70",
  null
  
)

export default component.exports